import Icon from '../components/Icon.vue'

Icon.register({
  'camera-retro': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M48 32C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V80C512 53.5 490.5 32 464 32H48zM48 64H154C157.3 64 160 66.7 160 70V90C160 93.3 157.3 96 154 96H38C34.7 96 32 93.3 32 90V80C32 71.2 39.2 64 48 64zM474 160H38C34.7 160 32 157.3 32 154V118C32 114.7 34.7 112 38 112H176L206.2 66.7C207.3 65 209.2 64 211.2 64H464C472.8 64 480 71.2 480 80V154C480 157.3 477.3 160 474 160zM256 424C189.8 424 136 370.2 136 304S189.8 184 256 184 376 237.8 376 304 322.2 424 256 424zM256 216C207.5 216 168 255.5 168 304S207.5 392 256 392 344 352.5 344 304 304.5 216 256 216zM208 320C199.2 320 192 312.8 192 304 192 268.7 220.7 240 256 240 264.8 240 272 247.2 272 256S264.8 272 256 272C238.4 272 224 286.4 224 304 224 312.8 216.8 320 208 320z'
      }
    ]
  }
})
